import { iSVGprops } from "assets/Icon";
import { FC } from "react";

export const Check:FC<iSVGprops> = ({ color="#1F1F1F" }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 12.0007L10.0007 17.0013L20.002 7" stroke={color} strokeWidth="2" strokeLinecap="square"/>
    </svg>
  );
};
